<template>
  <div id="login">
    <!-- TITLE//S-->
    <div class="page-header">
      <h3>{{ $t("verificationReset.residence.title") }}</h3>
    </div>
    <!-- TITLE//E-->
    <!-- TITLE//E-->
    <div class="login-info-text"></div>
    <!-- LOGIN FORM//S -->
    <div class="well login-wrap otp-register">
      <p class="title">{{ $t("residence.content[0].title") }}</p>
      <p>
        {{ $t("residence.content[0].content") }}
      </p>
      <p class="title">{{ $t("residence.content[1].title") }}</p>
      <p>
        {{ $t("residence.content[1].content") }}
      </p>
      <div class="button-wrap">
        <vs-button
          color="danger"
          class="btn-block custom send-email"
          type="filled"
          @click="popupActive = true"
        >
          {{ $t("residence.button") }}
        </vs-button>
      </div>
    </div>
    <!-- LOGIN FORM//E -->
    <vs-popup
      fullscreen
      :active.sync="popupActive"
      class="full-popup residence"
    >
      <div class="fullscreen-wrapper">
        <h1>{{ $t("residence.title") }}</h1>
        <p>아래 내용에 따라 인증서류를 등록해 주세요.</p>
        <div class="help">
          {{ $t("verificationReset.residence.notice") }}
        </div>
        <ul class="ul">
          <li class="li">
            <p>{{ $t("verificationReset.verificationDocuments.id.title") }}</p>
            <div class="id-card">
              <vs-input
                :placeholder="$t('verificationReset.residence.findFile')"
                class="input-block input-custom"
                disabled
                :value="files.idCard.name"
              ></vs-input>
              <input
                type="file"
                name="idCard"
                ref="idCardImg"
                style="display:none"
                @change="setFile"
              />
              <vs-button
                class="btn-agree-view"
                @click="$refs.idCardImg.click()"
                >{{ $t("verificationReset.residence.findFile") }}</vs-button
              >
            </div>
            <ul class="bill-help">
              <li
                class="bill"
                v-html="$t('verificationReset.residence.id.content[0]')"
              ></li>
              <li
                class="bill"
                v-html="$t('verificationReset.residence.id.content[1]')"
              ></li>
            </ul>
          </li>
          <li class="li">
            <p>
              {{ $t("verificationReset.verificationDocuments.photo.title") }}
            </p>
            <div class="id-card">
              <vs-input
                :placeholder="$t('verificationReset.residence.findFile')"
                class="input-block input-custom"
                disabled
                :value="files.withId.name"
              ></vs-input>
              <input
                type="file"
                name="withId"
                ref="withIdImg"
                style="display:none"
                @change="setFile"
              />
              <vs-button
                class="btn-agree-view"
                @click="$refs.withIdImg.click()"
                >{{ $t("verificationReset.residence.findFile") }}</vs-button
              >
            </div>
            <ul class="bill-help">
              <li
                class="bill"
                v-html="$t('verificationReset.residence.photo.content[0]')"
              ></li>
              <li
                class="bill"
                v-html="$t('verificationReset.residence.photo.content[1]')"
              ></li>
            </ul>
          </li>
          <li class="li">
            <p>
              {{
                $t("verificationReset.verificationDocuments.residence.title")
              }}
            </p>
            <div class="id-card">
              <vs-input
                :placeholder="$t('verificationReset.residence.findFile')"
                class="input-block input-custom"
                disabled
                :value="files.address.name"
              ></vs-input>
              <input
                type="file"
                name="address"
                ref="addressImg"
                style="display:none"
                @change="setFile"
              />
              <vs-button
                class="btn-agree-view"
                @click="$refs.addressImg.click()"
                >{{ $t("verificationReset.residence.findFile") }}</vs-button
              >
            </div>
            <ul class="bill-help">
              <li
                class="bill"
                v-html="
                  $t(
                    'verificationReset.verificationDocuments.residence.content[0]'
                  )
                "
              ></li>
              <li
                class="bill"
                v-html="
                  $t(
                    'verificationReset.verificationDocuments.residence.content[1]'
                  )
                "
              ></li>
              <li
                class="bill"
                v-html="
                  $t(
                    'verificationReset.verificationDocuments.residence.content[2]'
                  )
                "
              ></li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="btn-bottom-area">
        <vs-button @click="residenceCancel">{{
          $t("confirm.cancel")
        }}</vs-button>
        <vs-button @click.prevent="requestResidence">{{
          $t("residence.title")
        }}</vs-button>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import Api from "@/common/Api";
export default {
  data() {
    return {
      popupActive: false,
      files: {
        idCard: {},
        withId: {},
        address: {},
      },
    };
  },
  methods: {
    setFile($event) {
      const { name, files } = $event.target;
      if (!files.length) {
        return false;
      }
      // size 체크
      const fileMaxSize = 10485760;
      if (
        files[0].size > fileMaxSize ||
        !/\.(jpg|jpeg|png)$/i.test(files[0].name)
      ) {
        this.$vs.notify({
          text: this.$t("verificationReset.residence.messageNotice"),
          type: "warning",
          customClass: "dexko-noti",
          position: "top-left",
        });
        return false;
      }
      this.files[name] = files[0];
    },
    requestResidence() {
      // if(!this.uploadModalScrollEnd) {
      //   return false;
      // }
      // 세 파일 다 업로드 되었는지 판단
      if (_.some(this.files, (f) => !(f instanceof File))) {
        this.$vs.notify({
          title: "거주지 증명",
          text: "인증 서류를 모두 업로드 해주세요.",
          type: "warning",
          position: "top-left",
        });
        return false;
      }

      Api.User.RequestResidenceAuth({
        upfile1: this.files.idCard,
        upfile2: this.files.withId,
        upfile3: this.files.address,
      }).then((response) => {
        this.$vs.notify({
          title: "거주지 증명",
          text: "거주지 증명 신청이 완료되었습니다.",
          type: "warning",
          position: "top-left",
        });
        this.popupActive = false;
        this.residenceCancel();
        setTimeout(() => {
          this.$router.go(-1);
        }, 50);
      });
    },
    residenceCancel() {
      this.files = {
        idCard: {},
        withId: {},
        address: {},
      };
    },
  },
};
</script>
<style scoped></style>
